import {
  SelectFilterOperationType,
  valueFromString,
} from 'components/organisms/tasks/filters/select';
import { unreachable } from 'utils/unreachable';
import { Operation } from '../operations';

export const toType = (operation: Operation): SelectFilterOperationType => {
  switch (operation) {
    case Operation.IsEmpty:
      return SelectFilterOperationType.IsEmpty;
    case Operation.IsNotEmpty:
      return SelectFilterOperationType.IsNotEmpty;
    case Operation.Value:
      return SelectFilterOperationType.Is;
    case Operation.IsNot:
      return SelectFilterOperationType.IsNot;
    case Operation.OneOf:
      return SelectFilterOperationType.IsOneOf;
    case Operation.NoneOf:
      return SelectFilterOperationType.IsNoneOf;
    case Operation.HasValue:
    case Operation.IsNull:
    case Operation.Contains:
    case Operation.GreaterThan:
    case Operation.LessThan:
    default:
      return unreachable(operation as never);
  }
};

export const fromApiValue = valueFromString((value) => {
  const result = parseInt(value, 10);

  // NOTE:: for inferredProgress the value will be string and we need to return the string.
  return Number.isNaN(result) ? (value as unknown as number) : result;
}, ',');
